<template>
  <div v-if="!permission.capabilities.Create" class="animated fadeIn content-holder"> 
    <Page403></Page403>
  </div>
  <div v-else class="animated fadeIn content-holder">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>QR codes generator</strong>
          </div>

          <b-form v-on:submit.prevent="" v-on:reset.prevent="onReset" novalidate>

          <div> 
            <b-tabs v-model.lazy.trim="$v.form['currentTab'].$model" content-class="mt-2" fill>
              
              <!-- ### URL TAB ### -->
              <b-tab v-on:click="assignCurrentTab('0')" title="URL">
                  <b-col md="12">
                    <b-form-group label="Your Url" label-for="contentUrl">
                      <b-form-input id="contentUrl"
                        type="text"
                        v-model.lazy.trim="$v.form['contentUrl'].$model"
                        placeholder="Your Url"
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>   
              </b-tab>

              <!-- ### TEXT TAB ### -->
              <b-tab v-on:click="assignCurrentTab('1')" title="TEXT">
                  <b-col md="12">
                    <b-form-group label="Text"/>
                    <b-form-textarea label="Text" label-for="contentText"
                        type="text"
                        v-model.lazy.trim="$v.form['contentText'].$model"
                        placeholder="Text"
                        autofocus>
                    </b-form-textarea> 
                  </b-col> 
              </b-tab>

              <!-- ### EMAIL TAB ### -->
              <b-tab v-on:click="assignCurrentTab('2')" title="EMAIL">
                  <b-col md="12">
                    <b-form-group label="Your Email" label-for="contentEmailTo">
                      <b-form-input id="contentEmailTo"
                        type="text"
                        v-model.lazy.trim="$v.form['contentEmailTo'].$model"
                        placeholder="name@mail.com"
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>

                  <b-col md="12">
                    <b-form-group label="Your Email" label-for="contentEmailCC">
                      <b-form-input id="contentEmailCC"
                        type="text"
                        v-model.lazy.trim="$v.form['contentEmailCC'].$model"
                        placeholder="ccname@mail.com, ccname2@mail.com"
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                  
                  <b-col md="12">
                    <b-form-group label="Your Email" label-for="contentEmailBCC">
                      <b-form-input id="contentEmailBCC"
                        type="text"
                        v-model.lazy.trim="$v.form['contentEmailBCC'].$model"
                        placeholder="bccname@mail.com, bccname2@mail.com"
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                  
                  <b-col md="12">
                    <b-form-group label="Subject" label-for="contentEmailSubject">
                      <b-form-input id="contentEmailSubject"
                        type="text"
                        v-model.lazy.trim="$v.form['contentEmailSubject'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>

                  <b-col md="12">
                    <b-form-group label="Message"/>
                    <b-form-textarea label="Message" label-for="contentEmailBody"
                        type="text"
                        v-model.lazy.trim="$v.form['contentEmailBody'].$model"
                        placeholder=""
                        autofocus>
                    </b-form-textarea> 
                  </b-col>

              </b-tab>

              <!-- ### PHONE TAB ### -->
              <b-tab v-on:click="assignCurrentTab('3')" title="PHONE">
                  <b-col md="12">
                    <b-form-group label="Your Phone Number" label-for="contentPhoneNumber">
                      <b-form-input id="contentPhoneNumber"
                        type="number"
                        v-model.lazy.trim="$v.form['contentPhoneNumber'].$model"
                        placeholder="+49 172 45921...."
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
              </b-tab>

              <!-- ### SMS TAB ### -->
              <b-tab v-on:click="assignCurrentTab('4')" title="SMS">
                  <b-col md="12">
                    <b-form-group label="Your Phone Number" label-for="contentSmsNumber">
                      <b-form-input id="contentSmsNumber"
                        type="number"
                        v-model.lazy.trim="$v.form['contentSmsNumber'].$model"
                        placeholder="+49 172 45921...."
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                  
                  <b-col md="12">
                    <b-form-group label="Your Message"/>
                    <b-form-textarea label="Your Message" label-for="contentSmsMessage"
                        type="text"
                        v-model.lazy.trim="$v.form['contentSmsMessage'].$model"
                        placeholder="Text"
                        autofocus >
                    </b-form-textarea> 
                  </b-col> 
              </b-tab>

              <!-- ### VCARD TAB ### -->
              <b-tab v-on:click="assignCurrentTab('5')" title="VCARD">
                <!-- VCARD 1st row -->
                <b-row>
                  <b-col md="4">
                    <b-form-group label="Firstname" label-for="contentVcardFirstname">
                      <b-form-input id="contentVcardFirstname"
                        type="text"
                        v-model.lazy.trim="$v.form['contentVcardFirstname'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                  
                  <b-col md="4">
                    <b-form-group label="Lastname" label-for="contentVcardLastname">
                      <b-form-input id="contentVcardLastname"
                        type="text"
                        v-model.lazy.trim="$v.form['contentVcardLastname'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>

                  <b-col md="4">
                    <b-form-group label="Organization" label-for="contentVcardOrganization">
                      <b-form-input id="contentVcardOrganization"
                        type="text"
                        v-model.lazy.trim="$v.form['contentVcardOrganization'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                </b-row>

                <!-- VCARD 2nd row -->
                <b-row>
                  <b-col md="4">
                    <b-form-group label="Postion (Work)" label-for="contentVcardPostionWork">
                      <b-form-input id="contentVcardPostionWork"
                        type="text"
                        v-model.lazy.trim="$v.form['contentVcardPostionWork'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                  
                  <b-col md="4">
                    <b-form-group label="Phone (Work)" label-for="contentVcardPhoneWork">
                      <b-form-input id="contentVcardPhoneWork"
                        type="text"
                        v-model.lazy.trim="$v.form['contentVcardPhoneWork'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>

                  <b-col md="4">
                    <b-form-group label="Phone (Private)" label-for="contentVcardPhonePrivate">
                      <b-form-input id="contentVcardPhonePrivate"
                        type="text"
                        v-model.lazy.trim="$v.form['contentVcardPhonePrivate'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                </b-row>

                <!-- VCARD 3rd row -->
                <b-row>
                  <b-col md="4">
                    <b-form-group label="Phone (Mobile)" label-for="contentVcardPhoneMobile">
                      <b-form-input id="contentVcardPhoneMobile"
                        type="text"
                        v-model.lazy.trim="$v.form['contentVcardPhoneMobile'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                  
                  <b-col md="4">
                    <b-form-group label="Fax (Work)" label-for="contentVcardFaxWork">
                      <b-form-input id="contentVcardFaxWork"
                        type="text"
                        v-model.lazy.trim="$v.form['contentVcardFaxWork'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>

                  <b-col md="4">
                    <b-form-group label="Fax (Private)" label-for="contentVcardFaxPrivate">
                      <b-form-input id="contentVcardFaxPrivate"
                        type="text"
                        v-model.lazy.trim="$v.form['contentVcardFaxPrivate'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                </b-row>

                <!-- VCARD 4th row -->
                <b-row>
                  <b-col md="4">
                    <b-form-group label="Email" label-for="contentVcardEmail">
                      <b-form-input id="contentVcardEmail"
                        type="text"
                        v-model.lazy.trim="$v.form['contentVcardEmail'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                  
                  <b-col md="4">
                    <b-form-group label="Website" label-for="contentVcardWebsite">
                      <b-form-input id="contentVcardWebsite"
                        type="text"
                        v-model.lazy.trim="$v.form['contentVcardWebsite'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>

                  <b-col md="4">
                    <b-form-group label="Street" label-for="contentVcardStreet">
                      <b-form-input id="contentVcardStreet"
                        type="text"
                        v-model.lazy.trim="$v.form['contentVcardStreet'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                </b-row>

                <!-- VCARD 5th row -->
                <b-row>
                  <b-col md="4">
                    <b-form-group label="Zipcode" label-for="contentVcardZipcode">
                      <b-form-input id="contentVcardZipcode"
                        type="text"
                        v-model.lazy.trim="$v.form['contentVcardZipcode'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                  
                  <b-col md="4">
                    <b-form-group label="City" label-for="contentVcardCity">
                      <b-form-input id="contentVcardCity"
                        type="text"
                        v-model.lazy.trim="$v.form['contentVcardCity'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>

                  <b-col md="4">
                    <b-form-group label="State" label-for="contentVcardState">
                      <b-form-input id="contentVcardState"
                        type="text"
                        v-model.lazy.trim="$v.form['contentVcardState'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                </b-row>

                <!-- VCARD 6th row -->
                <b-row>
                  <b-col md="4">
                    <b-form-group label="Country" label-for="contentVcardCountry">
                      <b-form-input id="contentVcardCountry"
                        type="text"
                        v-model.lazy.trim="$v.form['contentVcardCountry'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                </b-row>
              </b-tab>

              <!-- ### MECARD TAB ### -->
              <b-tab v-on:click="assignCurrentTab('6')" title="MECARD">
                <!-- MECARD 1st row -->
                <b-row>
                  <b-col md="4">
                    <b-form-group label="Firstname" label-for="contentMecardFirstname">
                      <b-form-input id="contentMecardFirstname"
                        type="text"
                        v-model.lazy.trim="$v.form['contentMecardFirstname'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                  
                  <b-col md="4">
                    <b-form-group label="Lastname" label-for="contentMecardLastname">
                      <b-form-input id="contentMecardLastname"
                        type="text"
                        v-model.lazy.trim="$v.form['contentMecardLastname'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>

                  <b-col md="4">
                    <b-form-group label="Nickname" label-for="contentMecardNickname">
                      <b-form-input id="contentMecardNickname"
                        type="text"
                        v-model.lazy.trim="$v.form['contentMecardNickname'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                </b-row>
                  
                <!-- MECARD 2nd row -->
                <b-row>
                  <b-col md="4">
                    <b-form-group label="Phone 1" label-for="contentMecardPhone1">
                      <b-form-input id="contentMecardPhone1"
                        type="text"
                        v-model.lazy.trim="$v.form['contentMecardPhone1'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                  
                  <b-col md="4">
                    <b-form-group label="Phone 2" label-for="contentMecardPhone2">
                      <b-form-input id="contentMecardPhone2"
                        type="text"
                        v-model.lazy.trim="$v.form['contentMecardPhone2'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>

                  <b-col md="4">
                    <b-form-group label="Phone 3" label-for="contentMecardPhone3">
                      <b-form-input id="contentMecardPhone3"
                        type="text"
                        v-model.lazy.trim="$v.form['contentMecardPhone3'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                </b-row>

                <!-- MECARD 3rd row -->
                <b-row>
                  <b-col md="4">
                    <b-form-group label="Email" label-for="contentMecardEmail">
                      <b-form-input id="contentMecardEmail"
                        type="text"
                        v-model.lazy.trim="$v.form['contentMecardEmail'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                  
                  <b-col md="4">
                    <b-form-group label="Website" label-for="contentMecardWebsite">
                      <b-form-input id="contentMecardWebsite"
                        type="text"
                        v-model.lazy.trim="$v.form['contentMecardWebsite'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>

                  <b-col md="4">
                    <b-form-group label="Birthday" label-for="contentMecardBirthday">
                      <b-form-input id="contentMecardBirthday"
                        type="text"
                        v-model.lazy.trim="$v.form['contentMecardBirthday'].$model"
                        placeholder="YYYY-MM-DD"
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                </b-row>

                <!-- MECARD 4th row -->
                <b-row>
                  <b-col md="4">
                    <b-form-group label="Street" label-for="contentMecardStreet">
                      <b-form-input id="contentMecardStreet"
                        type="text"
                        v-model.lazy.trim="$v.form['contentMecardStreet'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                  
                  <b-col md="4">
                    <b-form-group label="Zipcode" label-for="contentMecardZipcode">
                      <b-form-input id="contentMecardZipcode"
                        type="text"
                        v-model.lazy.trim="$v.form['contentMecardZipcode'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>

                  <b-col md="4">
                    <b-form-group label="City" label-for="contentMecardCity">
                      <b-form-input id="contentMecardCity"
                        type="text"
                        v-model.lazy.trim="$v.form['contentMecardCity'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                </b-row>

                <!-- MECARD 5th row -->
                <b-row>
                  <b-col md="4">
                    <b-form-group label="State" label-for="contentMecardState">
                      <b-form-input id="contentMecardState"
                        type="text"
                        v-model.lazy.trim="$v.form['contentMecardState'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                  
                  <b-col md="4">
                    <b-form-group label="Country" label-for="contentMecardCountry">
                      <b-form-input id="contentMecardCountry"
                        type="text"
                        v-model.lazy.trim="$v.form['contentMecardCountry'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>

                  <b-col md="4">
                    <b-form-group label="Notes" label-for="contentMecardNotes">
                      <b-form-input id="contentMecardNotes"
                        type="text"
                        v-model.lazy.trim="$v.form['contentMecardNotes'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                </b-row>
              </b-tab>

                <!-- LOCATION -->
              <b-tab v-on:click="assignCurrentTab('7')" title="LOCATION">
                  <!-- <b-col md="4">
                    <b-form-group label="Your Address" label-for="contentLocationAddress">
                      <b-form-input id="contentLocationAddress"
                        type="text"
                        v-model.lazy.trim="$v.form['contentLocationAddress'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col> -->
                  
                <b-row>
                  
                  <b-col md="4">
                    <b-form-group label="Latitude" label-for="contentLocationLatitude">
                      <b-form-input id="contentLocationLatitude"
                        class="MapLat" value="" 
                        type="number"
                        v-model.lazy.trim="$v.form['contentLocationLatitude'].$model"
                        @change="gmapPositionUpdate()"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>

                  <b-col md="4">
                    <b-form-group label="Longtitude" label-for="contentLocationLongtitude">
                      <b-form-input id="contentLocationLongtitude" 
                        class="MapLon" value="" 
                        type="number"
                        v-model.lazy.trim="$v.form['contentLocationLongtitude'].$model"
                        @change="gmapPositionUpdate()"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                </b-row>
                <gmap-map ref="gmap"
                  :center="gmapCenter"
                  :zoom="7"
                  style="width: 500px; height: 300px"
                >
                  <gmap-marker
                    :key="index"
                    v-for="(m, index) in gmapMarkers"
                    :position="m.position"
                    :clickable="true"
                    :draggable="true"
                    @click="center=m.position;"
                    @dragend="latlngPositionUpdate()"
                  ></gmap-marker>
                </gmap-map>
              </b-tab>

                <!-- FACEBOOK -->
              <b-tab v-on:click="assignCurrentTab('8')" title="FACEBOOK">
                <!-- facebook radio select -->
                <b-form-group label="">
                  <b-form-radio v-on:change="assignFacebookRadio(1)" name="facebookradios" value="1">Facebook URL</b-form-radio>
                  <b-form-radio v-on:change="assignFacebookRadio(2)" name="facebookradios" value="2">Share URL</b-form-radio>
                </b-form-group>

                  <b-col md="4" v-if="contentFacebookRadio1">
                    <b-form-group label="Facebook URL" label-for="contentFacebookUrl">
                      <b-form-input id="contentFacebookUrl"
                        type="text"
                        v-model.lazy.trim="$v.form['contentFacebookUrl'].$model"
                        placeholder="https://facebook.com"
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>

                  <b-col md="4" v-if="contentFacebookRadio2">
                    <b-form-group label="Share your URL on Facebook" label-for="contentFacebookShareUrl">
                      <b-form-input id="contentFacebookShareUrl" 
                        type="text"
                        v-model.lazy.trim="$v.form['contentFacebookShareUrl'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
              </b-tab>
              
                <!-- TWITTER -->
              <b-tab v-on:click="assignCurrentTab('9')" title="TWITTER">
                <!-- TWITTER radio select -->
                <b-form-group label="">
                  <b-form-radio v-on:change="assignTwitterRadio(1)" name="twitterradios" value="1">Twitter URL</b-form-radio>
                  <b-form-radio v-on:change="assignTwitterRadio(2)" name="twitterradios" value="2">Tweet</b-form-radio>
                </b-form-group>

                  <b-col md="4" v-if="contentTwitterRadio1">
                    <b-form-group label="Your Twitter URL" label-for="contentTwitterUrl">
                      <b-form-input id="contentTwitterUrl"
                        type="text"
                        v-model.lazy.trim="$v.form['contentTwitterUrl'].$model"
                        placeholder="https://twitter.com"
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>

                  <b-col md="4" v-if="contentTwitterRadio2">
                    <b-form-group label="Your Tweet" label-for="contentTwitterTweet">
                      <b-form-input id="contentTwitterTweet" 
                        type="text"
                        v-model.lazy.trim="$v.form['contentTwitterTweet'].$model"
                        placeholder="@connect2 the platform for marketing engagement"
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
              </b-tab>

                <!-- YOUTUBE -->
              <b-tab v-on:click="assignCurrentTab('10')" title="YOUTUBE">
                  <b-col md="4">
                    <b-form-group label="Your Youtube URL" label-for="contentYoutubeUrl">
                      <b-form-input id="contentYoutubeUrl" 
                        type="text"
                        v-model.lazy.trim="$v.form['contentYoutubeUrl'].$model"
                        placeholder="https://youtube.com"
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
              </b-tab>

                <!-- WIFI -->
              <b-tab v-on:click="assignCurrentTab('11')" title="WIFI">
                  <b-col md="4">
                    <b-form-group label="Wireless SSID" label-for="contentWifiWirelessSSID">
                      <b-form-input id="contentWifiWirelessSSID"
                        type="text"
                        v-model.lazy.trim="$v.form['contentWifiWirelessSSID'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                  
                  <b-col md="4">
                    <b-form-group label="Password" label-for="contentWifiPassword">
                      <b-form-input id="contentWifiPassword"
                        type="text"
                        v-model.lazy.trim="$v.form['contentWifiPassword'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>

                  <b-col md="4">
                    <label id="contentWifiEncryption" class="d-block">Encryption</label>
                    <b-form-select id="contentWifiEncryption" label="Encryption" class="form-group"
                      :plain="true"
                      :options="this.encryptionOption"
                      v-model.lazy.trim="$v.form.contentWifiEncryption.$model"
                      value="Please select">                
                    </b-form-select>
                  </b-col>
              </b-tab>

              <b-tab v-on:click="assignCurrentTab('12')" title="EVENT">
                  <b-col md="12">
                    <b-form-group label="Event Title" label-for="contentEventTitle">
                      <b-form-input id="contentEventTitle"
                        type="text"
                        v-model.lazy.trim="$v.form['contentEventTitle'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Event Location" label-for="contentEventLocation">
                      <b-form-input id="contentEventLocation"
                        type="text"
                        v-model.lazy.trim="$v.form['contentEventLocation'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col> 
                  <b-col md="4">
                    <b-form-group label="Starttime" label-for="contentEventStarttime">
                      <b-form-input id="contentEventStarttime"
                        type="datetime-local" 
                        v-model.lazy.trim="$v.form['contentEventStarttime'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Endtime" label-for="contentEventEndtime">
                      <b-form-input id="contentEventEndtime"
                        type="datetime-local"
                        v-model.lazy.trim="$v.form['contentEventEndtime'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
              </b-tab>

              <b-tab v-on:click="assignCurrentTab('13')" label="Select Cryptocurrency" title="BITCOIN">
                  <b-form-radio-group
                  id="bitcoin-slots"
                  v-model.lazy.trim="$v.form['contentBitcoinCrypto'].$model"
                  :options="bitcoinCryptoOptions"
                  name="bitcoin-options-slots">
                  <!-- Radios in this slot will appear first -->
                    <!-- <template slot="first">
                      <b-form-radio value="bitcoin">Bitcoin</b-form-radio>
                    </template> -->
                  </b-form-radio-group>
              
                <b-row> 
                  <b-col md="8">
                    <b-form-group label="Address" label-for="contentBitcoinAddress">
                      <b-form-input id="contentBitcoinAddress"
                        type="text"
                        v-model.lazy.trim="$v.form['contentBitcoinAddress'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Amount" label-for="contentBitcoinAmount">
                      <b-form-input id="contentBitcoinAmount"
                        type="number"
                        v-model.lazy.trim="$v.form['contentBitcoinAmount'].$model"
                        placeholder=""
                        autofocus />
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </b-col>
                </b-row>
              </b-tab>
              
            </b-tabs>

          </div>

            <!--<b-form-group class="input-container" label="Csv file" label-for="csvFile" description="Select a QR code csv file" >
                <b-form-file id="csvFile" :plain="true"></b-form-file>
            </b-form-group> -->

            <!-- <div>
              <b-form-group v-if="status != 'running'" class="input-container" description="Give a name to your result QR codefile." label="Output file name"
              label-for="resultfileName" >
              <b-input-group>
              <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class='fa fa-qrcode'></i>
                  </span>
                </div>
                <b-form-input v-model="resultQRCodefile" id="resultfileName" type="text" autocomplete="fileName"></b-form-input>
              </b-input-group>
            </b-form-group>     
            </div> -->
                  
        

            <b-form-group v-if="status != 'running'">
              <b-form-checkbox-group stacked id="basicCustomCheckboxes">  
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="customChk1" value="0"  v-on:click="qrOptions = !qrOptions">
                  <label class="custom-control-label" for="customChk1">Options for QR codes</label>
                </div>
              </b-form-checkbox-group>
            </b-form-group>
            
            <transition name="fade">
              <div v-if="qrOptions"> 

                <!-- ### Logo to be insert in to QR-->
                  <!-- <div v-if="!image">
                      <b-form-group class="input-container" label="Logo" label-for="logoFile" description="Select your own custom logo image as .png, .jpg, .gif or .svg file format with a maximum size of 2 MB.">
                          <b-form-file type="file" v-model="logoFile" @change="onFileChange" id="logoFile" :plain="true"></b-form-file>
                      </b-form-group>
                  </div>
                  <div v-else>
                     <b-form-group class="input-container" label="Logo" label-for="logoFile" description="This image will be insert inside the QR code image">                  
                       <b-row md="12" >
                           <b-col cols="12" sm="4" md="2" xl class="mb-3 mb-xl-0">
                            <img :src="image" style="max-width:50%;width: auto;height: auto;"/>
                            <b-button style="max-width:200px;margin-top:20px;" @click="removeImage" block variant="primary">Remove logo</b-button>
                           </b-col>                   
                        </b-row>               
                     </b-form-group>
                  </div> -->
               
                <b-form-group class="input-container " label="QR code image format" label-for="qrcodeimageformat" >
                  <b-form-radio-group
                  v-model.lazy.trim="$v.form['fileType'].$model"
                    id="R"
                    value="1"
                    stacked>
                    <div class="custom-control custom-radio d-inline-block radio-pad" >
                      <input v-model="imgFormat" value="png" type="radio" id="radiopng" name="customRadio" class="custom-control-input" checked>
                      <label class="custom-control-label" for="radiopng">PNG</label>
                    </div>
                    <div class="custom-control custom-radio d-inline-block radio-pad">
                      <input v-model="imgFormat" value="svg" type="radio" id="radiosvg" name="customRadio" class="custom-control-input" >
                      <label class="custom-control-label" for="radiosvg" >SVG</label>
                    </div>  
                    <div class="custom-control custom-radio d-inline-block radio-pad">
                      <input v-model="imgFormat" value="pdf" type="radio" id="radiopdf" name="customRadio" class="custom-control-input" >
                      <label class="custom-control-label" for="radiopdf">PDF</label>
                    </div>         
                  </b-form-radio-group> 
                </b-form-group>            

              <div>
                <colorPicker class="w-50 d-inline-block" v-model="qrColorDark" name="qrColorDark" label="QR color dark tone" />
                <colorPicker class="w-50 d-inline-block" v-model="qrColorLight" name="qrColorLight" label="QR color light tone" />
              </div>

              <div>
                    <b-form-group class="w-50 d-inline-block" label="width and height in pixel:" label-for="qrWidth">
                      <b-form-input class="w-25 d-inline-block" id="qrWidth"
                        type="number" min="0" max="800"
                        v-model="qrWidth"
                        placeholder="pixel"
                        autofocus /> px
                      <b-form-input id="qrWidth"
                        type="range" min="0" max="800"
                        v-model="qrWidth"
                        placeholder="pixel"
                        autofocus />
                    </b-form-group> 

                    <b-form-group class="w-50 d-inline-block" label="Mask Pattern:" label-for="qrMaskPattern">
                      <b-form-input class="w-25 d-inline-block" id="qrMaskPattern"
                        type="number" min="0" max="7"
                        v-model="qrMaskPattern"
                        placeholder="pixel"
                        autofocus /> 
                      <b-form-input id="qrMaskPattern"
                        type="range" min="0" max="7"
                        v-model="qrMaskPattern"
                        placeholder="pixel"
                        autofocus />
                    </b-form-group> 
              </div>
              
              <div>
                    <b-form-group class="w-50 d-inline-block" label="QR dots per pixel scaling:" label-for="qrScale">
                      <b-form-input class="w-25 d-inline-block" id="qrScale"
                        type="number" min="1" max="7"
                        v-model="qrScale"
                        placeholder="pixel"
                        autofocus /> 
                      <b-form-input id="qrScale"
                        type="range" min="1" max="7"
                        v-model="qrScale"
                        placeholder="pixel"
                        autofocus />
                    </b-form-group> 
                    <b-form-group class="w-50 d-inline-block" label="QR quiet zone size:" label-for="qrQzone">
                      <b-form-input class="w-25 d-inline-block" id="qrQzone"
                        type="number" min="1" max="7"
                        v-model="qrQzone"
                        placeholder="pixel"
                        autofocus /> 
                      <b-form-input id="qrQzone"
                        type="range" min="1" max="7"
                        v-model="qrQzone"
                        placeholder="pixel"
                        autofocus />
                    </b-form-group> 
              </div>

                <div>
                    <b-form-group class="w-50 d-inline-block" label="Error Correction Level(L, M, Q, H):" label-for="qrErrorCorrectionLevel">
                      <b-form-group v-model="qrErrorCorrectionLevel">
                        <b-form-radio name="qrErrorCorrectionLevel" value="L">L</b-form-radio>
                        <b-form-radio name="qrErrorCorrectionLevel" value="M">M</b-form-radio>
                        <b-form-radio name="qrErrorCorrectionLevel" value="Q">Q</b-form-radio>
                        <b-form-radio name="qrErrorCorrectionLevel" value="H">H</b-form-radio>
                      </b-form-group>
                    </b-form-group> 

                    <b-form-group class="w-50 d-inline-block" label="QR border margin:" label-for="qrMargin">
                      <b-form-input class="w-25 d-inline-block" id="qrMargin"
                        type="number" min="0" max="7"
                        v-model="qrMargin"
                        placeholder="pixel"
                        autofocus /> 
                      <b-form-input id="qrMargin"
                        type="range" min="0" max="7"
                        v-model="qrMargin"
                        placeholder="pixel"
                        autofocus />
                    </b-form-group> 
              </div>
                <!-- ### Corner Options -->
                <!-- <b-form-group class="input-container corner-container" label="Corner color" label-for="corner-color">
                  <b-row md="12" class="corner-row">
                    <b-col md="6">
                      <colorPicker v-model="topleftcornercolor" name="topleftcornercolor" label="Top left corner" />                     
                    </b-col>
                    <b-col md="6">
                      <colorPicker v-model="toprightcornercolor" name="toprightcornercolor" label="Top right corner" />                  
                    </b-col>
                  </b-row>
                  <b-row md="12" class="corner-row">
                    <b-col md="6">
                      <colorPicker v-model="bottomleftcornercolor" name="bottomleftcornercolor" label="Bottom left corner" />
                    </b-col>
                    <b-col md="6">
                      <colorPicker v-model="bottomrightcornercolor" name="bottomrightcornercolor" label="Bottom right corner" />
                    </b-col>
                  </b-row>
                </b-form-group>  -->
               
              </div>
            </transition>

            <b-form-group class="input-container" >
              Current Status: 
              <div style="font-size:2em;">
                <div v-if="status === 'idle'">
                  <b-badge class="m-2" variant="secondary">idle</b-badge>
                  <div style="width:50%"><b-progress :value="100" :max="100" show-progress animated></b-progress></div>
                </div>
                <div v-else-if="status === 'running'">
                  <div style="display:flex;align-items: center;">
                    <b-badge class="m-3" variant="primary">
                      In progress...
                    </b-badge>


                    <div class="sk-cube-grid" style="display:inline-block">
                        <div class="sk-cube sk-cube1"></div>
                        <div class="sk-cube sk-cube2"></div>
                        <div class="sk-cube sk-cube3"></div>
                        <div class="sk-cube sk-cube4"></div>
                        <div class="sk-cube sk-cube5"></div>
                        <div class="sk-cube sk-cube6"></div>
                        <div class="sk-cube sk-cube7"></div>
                        <div class="sk-cube sk-cube8"></div>
                        <div class="sk-cube sk-cube9"></div>
                    </div>
                  </div>
                </div>

                <div v-else-if="status === 'success'">
                  <b-badge class="m-1" variant="success">Success</b-badge>
                </div>
                <div v-else>
                  <b-badge class="m-1" variant="danger">Error</b-badge>
                </div>
                    <img id="downloadingImage" src="" style="background: black;">
              </div>
            </b-form-group>


            <diV>
              <img id="qrcode"/>
            </diV>
            <!-- buttons -->
            <div slot="footer" class="btn-qrcode-container">
              <b-button :disabled="!btnActive" v-on:click="submit" type="submit" size="lg" variant="primary btn-square"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
              <b-button :disabled="!btnActive" type="reset" size="lg" variant="danger btn-square"><i class="fa fa-ban"></i> Reset</b-button>
            </div>
          </b-form>
        </b-card>
       
      </b-col>
      <b-col md="6"></b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import { validationMixin } from "vuelidate";
import { required, minLength, email, sameAs, helpers } from "vuelidate/lib/validators";
import { apigClient } from '@/shared/api';
import Page403 from "@/views/pages/Page403.vue";
import { router } from '@/router/index';

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBvWE_sIwKbWkiuJQOf8gSk9qzpO96fhfY',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
})
const axios = require('axios');
//import { Foo } from 'foo'
/*
  v-model is just syntactic sugar for:
  <input
    v-bind:value="something"
    v-on:input="something = $event.target.value">
    
  To implement the v-model directive for a custom component:
  - specify a value prop for the component
  - set a data property to the value of the value prop in the data method (since you should not modify the value of a prop from within a component).
  - emit an input event with the value of the data property whenever it changes
*/
// todo: put this in a separate file
// usage: <colorPicker v-model="backgroundcolor" name="backgroundcolor" label="Background color" />
const formShape = {
    currentTab: 0,
    fileType: "",
    content: "",
    contentUrl: "",
    contentText: "", 
    contentEmailTo: "",
    contentEmailCC: "",
    contentEmailBCC: "",
    contentEmailSubject: "",
    contentEmailBody: "",
    contentPhoneNumber: "",
    contentSmsNumber: "",
    contentSmsMessage: "",
    contentVcardFirstname: "",
    contentVcardLastname: "",
    contentVcardOrganization: "",
    contentVcardPostionWork: "",
    contentVcardPhoneWork: "",
    contentVcardPhonePrivate: "",
    contentVcardPhoneMobile: "",
    contentVcardFaxWork: "",
    contentVcardFaxPrivate: "",
    contentVcardEmail: "",
    contentVcardWebsite: "",
    contentVcardStreet: "",
    contentVcardZipcode: "",
    contentVcardCity: "",
    contentVcardState: "",
    contentVcardCountry: "",
    contentMecardFirstname: "",
    contentMecardLastname: "",
    contentMecardNickname: "",
    contentMecardPhone1: "",
    contentMecardPhone2: "",
    contentMecardPhone3: "",
    contentMecardEmail: "",
    contentMecardWebsite: "",
    contentMecardBirthday: "",
    contentMecardStreet: "",
    contentMecardZipcode: "",
    contentMecardCity: "",
    contentMecardState: "",
    contentMecardCountry: "",
    contentMecardNotes: "",
    contentLocationAddress: "",
    contentLocationLatitude: -33.868820,
    contentLocationLongtitude:  151.2092903,
    contentFacebookUrl: "",
    contentFacebookShareUrl: "",
    contentTwitterUrl: "",
    contentTwitterTweet: "",
    contentYoutubeUrl: "",
    contentWifiWirelessSSID: "",
    contentWifiPassword: "",
    contentWifiEncryption: "",
    contentEventTitle: "",
    contentEventLocation: "",
    contentEventStarttime: "",
    contentEventEndtime: "",
    contentBitcoinCrypto: "",
    contentBitcoinAddress: "",
    contentBitcoinAmount: "",
}
let validations = {
  form: {
    currentTab: {},
    fileType: {},
    content: {},
    contentUrl: {},
    contentText: {},
    contentEmailTo: {},
    contentEmailCC: {},
    contentEmailBCC: {},
    contentEmailSubject: {},
    contentEmailBody: {},
    contentPhoneNumber: {},
    contentSmsNumber: {},
    contentSmsMessage: {},
    contentVcardFirstname: {},
    contentVcardLastname: {},
    contentVcardOrganization: {},
    contentVcardPostionWork: {},
    contentVcardPhoneWork: {},
    contentVcardPhonePrivate: {},
    contentVcardPhoneMobile: {},
    contentVcardFaxWork: {},
    contentVcardFaxPrivate: {},
    contentVcardEmail: {},
    contentVcardWebsite: {},
    contentVcardStreet: {},
    contentVcardZipcode: {},
    contentVcardCity: {},
    contentVcardState: {},
    contentVcardCountry: {},
    contentMecardFirstname: {},
    contentMecardLastname: {},
    contentMecardNickname: {},
    contentMecardPhone1: {},
    contentMecardPhone2: {},
    contentMecardPhone3: {},
    contentMecardEmail: {},
    contentMecardWebsite: {},
    contentMecardBirthday: {},
    contentMecardStreet: {},
    contentMecardZipcode: {},
    contentMecardCity: {},
    contentMecardState: {},
    contentMecardCountry: {},
    contentMecardNotes: {},
    contentLocationAddress: {},
    contentLocationLatitude: {},
    contentLocationLongtitude: {},
    contentFacebookUrl: {},
    contentFacebookShareUrl: {},
    contentTwitterUrl: {},
    contentTwitterTweet: {},
    contentYoutubeUrl: {},
    contentWifiWirelessSSID: {},
    contentWifiPassword: {},
    contentWifiEncryption: {},
    contentEventTitle: {},
    contentEventLocation: {},
    contentEventStarttime: {},
    contentEventEndtime: {},
    contentBitcoinCrypto: {},
    contentBitcoinAddress: {},
    contentBitcoinAmount: {},
  }
}
Vue.component('colorPicker', {
  props: { 
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    value : {
      type: String,
      required: false
    },
  },
  //a component’s data option must be a function, so that each instance can maintain an independent copy of the returned data wallet
  data: function () {
    return { inputVal: this.value }
  },
  watch: {
    inputVal(val) {
      this.$emit('input', val);
    }
  },
  template: `
    <b-form-group class="input-container" :label="label" :label-for="name" >
        <b-input-group class="custom-color">
          <b-form-input v-model="inputVal" type="color" ></b-form-input>
        </b-input-group>
      </b-form-group>
    </b-col>
  `
});
export default {
  name: 'qr-maker',
  components: {
    Page403
  },
  data () {
    let loginUserInfo = JSON.parse(localStorage.getItem('loginUserInfo'));
    return {
      loginUserInfo: loginUserInfo,
      permission: {
        permissionBaseName: null,
        permissionBaseNameCapabilities: null,
        capabilities: {
          View: false,
          Edit: false,
          Delete: false,
          Create: false,
        }
      },
      title:'QRcodeGenerator',
      // for G map marker //
      gmapCenter: {lat: -33.868820, lng: 151.2092903},
      gmapMarkers: [{
          position: {lat: -33.868820, lng: 151.209290}
        }],
      latlongPosition: '',
      form: Object.assign({}, formShape),
      selected: [], // Must be an array reference!
      encryptionOption: ['no encryption','WEP','WPA/WPA2'],
      status: 'idle',
      btnActive: true,
      resultQRCodefile: '',
      qrOptions: false,
      imgFormats: [{name:"PNG", id:0},{name:"SVG",id:1}],
      imgFormat: 'PNG',
      logoFile: '',
      image: '',
      qrColorDark: '#000000',
      qrColorLight: '#FFFFFF',
      qrWidth: '400',
      qrScale: '4',
      qrQzone: '4',
      qrMargin: '0',
      qrErrorCorrectionLevel: 'H',
      qrMaskPattern: '4',
      topleftcornercolor:'#000000',
      toprightcornercolor:'#000000',
      bottomleftcornercolor:'#000000',
      bottomrightcornercolor:'#000000',
      bitcoinCryptoOptions: [
          { text: 'Bitcoin', value: 'bitcoin' },
          { text: 'Bitcoin Cash', value: 'bitcoincash' },
          { text: 'Ethereum', value: 'ethereum' },
          { text: 'Litecoin', value: 'litecoin' },
          { text: 'Dash', value: 'dash' }
        ],
      currentTab: "0",
      fileType: "PNG",
      content: "",
      contentUrl: "",
      contentText: "", 
      contentEmailTo: "",
      contentEmailCC: "",
      contentEmailBCC: "",
      contentEmailSubject: "",
      contentEmailBody: "",
      contentPhoneNumber: "",
      contentSmsNumber: "",
      contentSmsMessage: "",
      contentVcardFirstname: "",
      contentVcardLastname: "",
      contentVcardOrganization: "",
      contentVcardPostionWork: "",
      contentVcardPhoneWork: "",
      contentVcardPhonePrivate: "",
      contentVcardPhoneMobile: "",
      contentVcardFaxWork: "",
      contentVcardFaxPrivate: "",
      contentVcardEmail: "",
      contentVcardWebsite: "",
      contentVcardStreet: "",
      contentVcardZipcode: "",
      contentVcardCity: "",
      contentVcardState: "",
      contentVcardCountry: "",
      contentMecardFirstname: "",
      contentMecardLastname: "",
      contentMecardNickname: "",
      contentMecardPhone1: "",
      contentMecardPhone2: "",
      contentMecardPhone3: "",
      contentMecardEmail: "",
      contentMecardWebsite: "",
      contentMecardBirthday: "",
      contentMecardStreet: "",
      contentMecardZipcode: "",
      contentMecardCity: "",
      contentMecardState: "",
      contentMecardCountry: "",
      contentMecardNotes: "",
      contentLocationAddress: "",
      contentLocationLatitude: "",
      contentLocationLongtitude: "",
      contentFacebookRadio1: "",
      contentFacebookRadio2: "",
      contentFacebookUrl: "",
      contentFacebookShareUrl: "",
      contentTwitterRadio1: "",
      contentTwitterRadio2: "",
      contentTwitterUrl: "",
      contentTwitterTweet: "",
      contentYoutubeUrl: "",
      contentWifiWirelessSSID: "",
      contentWifiPassword: "",
      contentWifiEncryption: "",
      contentEventTitle: "",
      contentEventLocation: "",
      contentEventStarttime: "",
      contentEventEndtime: "",
      contentBitcoinCrypto: "",
      contentBitcoinAddress: "",
      contentBitcoinAmount: "",
    }
  },
  mounted() {
    let that = this;
    that.getPermission();
    if(!that.permission.capabilities.Create){
      return;
    }
  },
  computed: {
    formStr() { return JSON.stringify(this.form, null, 4) },
    isValid() { return !this.$v.form.$anyError },
    isDirty() { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: validations,
  methods: {
    getPermission(){
      let that = this;
      const userPermissionsBasedOnEntity = that.loginUserInfo.db.userPermissionsBasedOnEntity;
      if(this.$route.meta && userPermissionsBasedOnEntity){
        that.permission.permissionBaseName = this.$route.meta.permissionBaseName;
        let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(p => p.permissionBaseName === this.$route.meta.permissionBaseName);
        if(userPermissionBasedOnEntity){
          that.permission.permissionBaseNameCapabilities = userPermissionBasedOnEntity.capabilities;
          that.permission.permissionBaseNameCapabilities.forEach(capability=>{
            that.permission.capabilities[capability.label] = capability.value
          });
        } 
      } else{
        router.push('/no-permission-given');
      }
      console.log('permission: ' , that.permission);
    },
    onReset() {
      // Reset validation
      this.form = Object.assign({}, formShape)
      this.submitted = false
      this.$nextTick(() => {
        this.$v.$reset()
        this.feedBack = 'secondary'
      })
    },
    assignCurrentTab(value){
      this.currentTab = value;console.log(this.currentTab);
    },
    assignTwitterRadio(value){
      switch(value){
        case 1: this.contentTwitterRadio1 = true; this.contentTwitterRadio2 = false; break;
        case 2: this.contentTwitterRadio2 = true; this.contentTwitterRadio1 = false; break;
      }
    },
    assignFacebookRadio(value){
      switch(value){
        case 1: this.contentFacebookRadio1 = true; this.contentFacebookRadio2 = false; break;
        case 2: this.contentFacebookRadio2 = true; this.contentFacebookRadio1 = false; break;
      }
    },
    gmapPositionUpdate(){
      this.gmapCenter = {lat: parseFloat(this.form.contentLocationLatitude), lng: parseFloat(this.form.contentLocationLongtitude) }
      this.gmapMarkers = [{
          position: {lat: parseFloat(this.form.contentLocationLatitude), lng: parseFloat(this.form.contentLocationLongtitude)}
        }]
    },
    latlngPositionUpdate(){
      console.log(this.m)
      this.contentLocationLatitude = this.gmapMarkers[0]['position']['lat'].toString()
      this.contentLocationLongtitude = this.gmapMarkers[0]['position']['lng'].toString()
      console.log(this.gmapMarkers); 
      console.log(this.gmapCenter);
      console.log(this.contentLocationLatitude);
    },
    submit () {
      let that = this;
      switch(this.currentTab){
        case "0": // contentUrl
        this.content = `URLTO:${this.form.contentUrl}`;
        // this.content = "URLTO:" + this.form.contentUrl;
        break;
        case "1": // contentText
        this.content = this.form.contentText;
        break;
        case "2": // contentEmail
        this.content = `mailto:${this.form.contentEmailTo}?cc=${this.form.contentEmailCC}&bcc=${this.form.contentEmailBCC}&subject=${this.form.contentEmailSubject}&body=${this.form.contentEmailBody}`;
        break;
        case "3": // contentPhone
        this.content = `tel:${this.form.contentPhoneNumber}`;
        break;
        case "4": // contentSms
        this.content = `SMSTO:${this.form.contentSmsNumber}:${this.form.contentSmsMessage}`;
        break;
        case "5": // contentVcard
        this.content = `BEGIN:VCARD\
        \nVERSION:4.0\
        \nN:${this.form.contentVcardFirstname},${this.form.contentVcardLastname};\
        \nORG:${this.form.contentVcardOrganization}\
        \nTITLE:${this.form.contentVcardPostionWork}\
        \nTEL;TYPE=work,voice;VALUE=uri:tel:${this.form.contentVcardPhoneWork}\
        \nTEL;TYPE=home,voice;VALUE=uri:tel:${this.form.contentVcardPhonePrivate}\
        \nTEL;TYPE=home,cell,voice;VALUE=uri:tel:${this.form.contentVcardPhoneMobile}\
        \nTEL;TYPE=work,fax;VALUE=uri:tel:${this.form.contentVcardFaxWork}\
        \nTEL;TYPE=home,fax;VALUE=uri:tel:${this.form.contentVcardFaxPrivate}\
        \nEMAIL:${this.form.contentVcardEmail}\
        \nURL:${this.form.contentVcardWebsite}\
        \nADR;TYPE=home:;;${this.form.contentVcardStreet}; ${this.form.contentVcardCity};${this.form.contentVcardState};${this.form.contentVcardZipcode};${this.form.contentVcardCountry}\
        \nEND:VCARD`;
        break;
        case "6": // contentMecard
        this.content = `MECARD:N:${this.form.contentMecardFirstname},${this.form.contentMecardLastname};\
        NICKNAME:${this.form.contentMecardNickname};\
        ADR:${this.form.contentMecardStreet}, ${this.form.contentMecardCity}, ${this.form.contentMecardState}, ${this.form.contentMecardZipcode}, ${this.form.contentMecardCountry};\
        TEL:${this.form.contentMecardPhone1};\
        TEL:${this.form.contentMecardPhone2};\
        TEL:${this.form.contentMecardPhone3};\
        EMAIL:${this.form.contentMecardEmail};\
        NOTE:${this.form.contentMecardNotes};\
        URL:${this.form.contentMecardWebsite};\
        BDAY:${this.form.contentMecardBirthday};;`;
        break;
        case "7": // contentLocation
        this.content = `geo:${this.form.contentLocationLatitude},${this.form.contentLocationLongtitude}`; 
        // ex. NewYork office 100m above ground "geo:40.71872,-73.98905,100".
        break;
        case "8": // contentFacebook
        if(contentFacebookRadio1){
        this.content = `URLTO:${this.form.contentFacebookUrl}`;
        }else if(contentFacebookRadio2){
        this.content = `URLTO:${this.form.contentFacebookShareUrl}`;
        }
        break;
        case "9": // contentTwitter
        if(contentTwitterRadio1){
        this.content = `URLTO:${this.form.contentTwitterUrl}`;
        }else if(contentTwitterRadio2){
        this.content = `URLTO:${this.form.contentTwitterTweet}`;
        }
        case "10": // contentYoutube
        this.content = `URLTO:${this.form.contentYoutubeUrl}`;
        break;
        case "11": // contentWifi
        this.content = `WIFI:T:${this.form.contentWifiEncryption};S:${this.form.contentWifiWirelessSSID};P:${this.form.contentWifiPassword};;`
        break;
        case "12": // contentEvent
        let contentEventStarttime = this.form.contentEventStarttime.replace(/[^\w\s]/gi, '')
        let contentEventEndtime = this.form.contentEventEndtime.replace(/[^\w\s]/gi, '')
        this.content = `BEGIN:VEVENT\
        \nSUMMARY:${this.form.contentEventTitle}, ${this.form.contentEventLocation}\
        \nDTSTART:${contentEventStarttime}00Z\
        \nDTEND:${contentEventEndtime}00Z\
        \nEND:VEVENT`;
        // .ics calendar time format  ex.20180601T070000Z, 20180831T070000Z
        break;
        case "13": // contentBitcoin
        this.content = `${this.form.contentBitcoinCrypto}:${this.form.contentBitcoinAddress}?amount=${this.form.contentBitcoinAmount}`;
        break;
        default:
        this.content = `http://cn2.ypb.io`;
        }
      this.btnActive = false;
      this.createImages = false;
      this.status = 'running'
      //post data here and get the token in response 
            var method = 'POST';
            var pathTemplate = '/qrcodes';
            var additionalParams ={
            };
            var body = {
                content: this.content, 
                logoUrl: this.form.logoUrl,              
                fileType: this.form.fileType,
                walletSegmentId: this.form.walletSegmentId,
                companyWebsite: this.form.companyWebsite,
                companyId: this.form.companyId,
                width: this.form.width,
                margin: this.form.margin,
                errorCorrectionLevel: this.form.errorCorrectionLevel,
                maskPattern: this.form.maskPattern,
                scale: this.form.scale,
                qzone: this.form.qzone,
                colorDark: this.qrColorDark,
                colorLight: this.qrColorLight,
            };
            var pathParams = {
            };
            apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams, body)
              .then(function(result){ 
                console.log('Success on post data for generating qrcode');
                console.log(result.data);
                // let image = document.images[0];
                // var downloadingImage = new Image();
                // downloadingImage.onload = function(){
                //     image.src = that.src;   
                // };
                console.log(result);
                document.getElementById("downloadingImage").src = result.data;  

                that.status = 'success'  
              }).catch( function(error){
                console.log('Error on post data for generating qrcode: ' + error); 
                that.status = 'Error! Could not reach the API. ' + error 
            });
      //Then use a setInterval to check if result is ready (use the token) 
      // var vm = this;
      // axios.get('https://yesno.wtf/api')
      //   .then(function () {
      //     //vm.answer = _.capitalize(response.data.answer)
      //     vm.status = "success";
      //   })
      //   .catch(function (error) {
      //     vm.status = 'Error! Could not reach the API. ' + error
      //   })
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.createImage(files[0]);
    },
    createImage(file) {
      //var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function () {
      this.image = '';
    }
  }
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.btn-qrcode-container {
  display: flex;
  justify-content: space-between;
}
.input-container{
  padding:5px;
  border: 1px dotted #c8ced3;
  
}
.sk-cube-grid {
    width: 32px;
    height: 32px;
    margin: 0;
}
.sk-cube-grid .sk-cube {
  background-color: #16a4d3;
}
.m-3 {
  margin: 4px !important;
}
.badge{
  border-radius: 0;
}
.corner{
  width: 35px;
}
.corner-row{
  /*height:55px;*/
}
.corner-container {
  /*width: 500px;
  background-image: url("qrcode.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: left; */
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
 .sk-fading-circle .sk-circle {
    margin: 0 auto;
  }
  .sk-three-bounce {
    height: 40px;
  }
  input[type="color"]{
    width:100px!important;
    height:30px!important;
  }
  .radio-pad{
    padding-left: 5%;
  }
</style>

<style src="spinkit/scss/spinkit.scss" lang="scss" />
